export class BreadCrumb {
    id: number;
    name: string;
    type: string;
    allowedOperation : number

    constructor(id: number, name: string, type: string, allowedOperation: number) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.allowedOperation = allowedOperation;
    }
}
